<template>
  <div v-if="eventSummary.length">
    <div class="section-margin py-0">
      <hr />
    </div>
    <!-- EVENT ABOUT -->
    <div class="media mx-1 py-0 is-size-6">
      <div class="content">
        <h3 class="is-section-headline mt-0">{{ $t('ui.aboutEvent') }}</h3>

        <p
          itemprop="description"
          class="mb-0 event-summary is-paragraph is-size-14px"
          :class="{'is-truncated': isTruncated }"
          style="white-space: pre-wrap;"
        >{{ eventSummary }}</p>

        <div class="is-size-14px  is-more-btn" v-if="isTruncated">
          <span
            @click="isTruncated = false"
            class="is-pulled-right has-text-link cursor-pointer"
          >{{ $t('ui.readMore') }}</span>
        </div>
        <!-- <p v-else>{{ event.details.eventSummary }}</p> -->
      </div>
    </div>

    <!-- ./EVENT ABOUT -->
  </div>
</template>

<script>
export default {
  props: {
    eventSummary: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isTruncated: false
    };
  },
  created() {
    if (this.eventSummary.length > 200) {
      this.isTruncated = true
    }
  }
};
</script>

<style>
.content {
  position: relative;
}
.is-paragraph.is-truncated {
  height: calc(21px * 4);
  overflow: hidden;
  -webkit-mask: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0px,
      rgba(0, 0, 0, 0) 18.0001px,
      rgb(0, 0, 0) 18.0001px
    ),
    linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0px,
      rgba(0, 0, 0, 0) 72.8px,
      rgb(0, 0, 0) 108.8002px
    );
}

.is-more-btn {
  width: 100%;
  position: absolute;
  bottom: 0;
  float: initial;
  left: 0;
  z-index: 50;
}
.is-more-btn span {
  padding-left: 8px;
  box-shadow: inset 12px 12px 1px 0px transparent;
  background-color: white;
}
</style>